import OverChargeClaimsTypes from './OverChargeTypes';

export const setClaimsOverChargeFilters = (payload) => {
  return {
    type: OverChargeClaimsTypes.SET_OVERCHARGE_FILTERS,
    payload,
  };
};
export const setOverChargeClaimEditActiveKey = (payload) => {
  return {
    type: OverChargeClaimsTypes.SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY,
    payload,
  };
};
export const getOverChargeClamsListInProgress = (payload) => {
  return { type: OverChargeClaimsTypes.GET_OVERCHARGE_LIST_PROGRESS, payload };
};
export const getOverChargeClamsListInSuccess = (payload) => {
  return { type: OverChargeClaimsTypes.GET_OVERCHARGE_LIST_SUCCESS, payload };
};
export const getOverChargeClamsListInError = (payload) => {
  return { type: OverChargeClaimsTypes.GET_OVERCHARGE_LIST_ERROR, payload };
};
export const setOverchargeList = (payload) => {
  return { type: OverChargeClaimsTypes.SET_OVERCHARGE_LIST, payload };
};

export const setOverChargeClaimsEditDrawer = (payload) => {
  return {
    type: OverChargeClaimsTypes.SET_OVERCHARGE_EDIT_DRAWER,
    payload,
  };
};

export const setSelectedOverChargeClaims = (payload) => {
  return {
    type: OverChargeClaimsTypes.SET_SELECTED_OVERCHARGE_CLAIMS,
    payload,
  };
};

export const deleteOverChargeClaimsInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.DELETE_OVERCHARGE_CLAIM_PROGRESS,
    payload,
  };
};

export const getOverChargeClaimDetailsInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_OVERCHARGE_CLAIM_DETAILS_PROGRESS,
    payload,
  };
};
export const getOverChargeClaimDetailsInSuccess = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_OVERCHARGE_CLAIM_DETAILS_SUCCESS,
    payload,
  };
};
export const getOverChargeClaimDetailsInError = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_OVERCHARGE_CLAIM_DETAILS_ERROR,
    payload,
  };
};

export const updateOverChargeClaimInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.UPDATE_OVERCHARGE_CLAIM_PROGRESS,
    payload,
  };
};

export const sendOverChargeClaimPdfToCarrierInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.SEND_CLAIM_PDF_TO_CARRIER_PROGRESS,
    payload,
  };
};
export const sendOverChargeClaimPdfToCarrierInSuccess = (payload) => {
  return {
    type: OverChargeClaimsTypes.SEND_CLAIM_PDF_TO_CARRIER_SUCCESS,
    payload,
  };
};
export const sendOverChargeClaimPdfToCarrierInError = (payload) => {
  return {
    type: OverChargeClaimsTypes.SEND_CLAIM_PDF_TO_CARRIER_ERROR,
    payload,
  };
};

export const getOverChargeClaimEmailDetailsInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_CLAIM_EMAIL_HISTORY_PROGRESS,
    payload,
  };
};
export const getOverChargeClaimEmailDetailsInSuccess = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_CLAIM_EMAIL_HISTORY_SUCCESS,
    payload,
  };
};
export const getOverChargeClaimEmailDetailsInError = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_CLAIM_EMAIL_HISTORY_ERROR,
    payload,
  };
};

export const getOverChargeItemsFromExcelInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_PROGRESS,
    payload,
  };
};
export const getOverChargeItemsFromExcelInSuccess = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_SUCCESS,
    payload,
  };
};
export const getOverChargeItemsFromExcelInError = (payload) => {
  return {
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_ERROR,
    payload,
  };
};

export const createOverchargeClaimReset = (payload) => ({
  type: OverChargeClaimsTypes.CREATE_OVERCHARGE_CLAIM_RESET,
  payload,
});
export const createOverchargeClaimInProgress = (payload) => {
  return {
    type: OverChargeClaimsTypes.CREATE_OVERCHARGE_CLAIM_PROGRESS,
    payload,
  };
};
export const createOverchargeClaimInSuccess = (payload) => {
  return {
    type: OverChargeClaimsTypes.CREATE_OVERCHARGE_CLAIM_SUCCESS,
    payload,
  };
};
export const createOverchargeClaimInError = (payload) => {
  return {
    type: OverChargeClaimsTypes.CREATE_OVERCHARGE_CLAIM_ERROR,
    payload,
  };
};

export const setOCClaimViewType = (payload) => ({
  type: OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE,
  payload,
});
export const setOCClaimViewTypeInitial = (payload) => ({
  type: OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL,
  payload,
});

export const getOCClaimsTableViewColumnsInProgress = (payload) => ({
  type: OverChargeClaimsTypes.GET_TABLE_VIEW_COLUMNS_PROGRESS,
  payload,
});
export const getOCClaimsTableViewColumnsInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.GET_TABLE_VIEW_COLUMNS_SUCCESS,
  payload,
});
export const getOCClaimsTableViewColumnsInError = (payload) => ({
  type: OverChargeClaimsTypes.GET_TABLE_VIEW_COLUMNS_ERROR,
  payload,
});

export const getOCClaimsSortingFieldsInProgress = (payload) => ({
  type: OverChargeClaimsTypes.GET_SORTING_FIELDS_PROGRESS,
  payload,
});
export const getOCClaimsSortingFieldsInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.GET_SORTING_FIELDS_SUCCESS,
  payload,
});
export const getOCClaimsSortingFieldsInError = (payload) => ({
  type: OverChargeClaimsTypes.GET_SORTING_FIELDS_ERROR,
  payload,
});

export const saveOCClaimsTableViewColumnsInProgress = (payload) => ({
  type: OverChargeClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_PROGRESS,
  payload,
});
export const saveOCClaimsTableViewColumnsInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_SUCCESS,
  payload,
});
export const saveOCClaimsTableViewColumnsInError = (payload) => ({
  type: OverChargeClaimsTypes.SAVE_TABLE_VIEW_COLUMNS_ERROR,
  payload,
});

export const getOCClaimNotesInProgress = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_NOTES_PROGRESS,
  payload,
});
export const getOCClaimNotesInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_NOTES_SUCCESS,
  payload,
});
export const getOCClaimNotesInError = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_NOTES_ERROR,
  payload,
});

export const getOCClaimSettlementsInProgress = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_SETTLEMENTS_PROGRESS,
  payload,
});
export const getOCClaimSettlementsInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_SETTLEMENTS_SUCCESS,
  payload,
});
export const getOCClaimSettlementsInError = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_SETTLEMENTS_ERROR,
  payload,
});

export const getOCClaimItemsInProgress = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_ITEMS_PROGRESS,
  payload,
});
export const getOCClaimItemsInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_ITEMS_SUCCESS,
  payload,
});
export const getOCClaimItemsInError = (payload) => ({
  type: OverChargeClaimsTypes.GET_CLAIM_ITEMS_ERROR,
  payload,
});
export const applyClaimRecoveryPercentInProgress = (payload) => ({
  type: OverChargeClaimsTypes.APPLY_CLAIM_RECOVERY_PERCENT_PROGRESS,
  payload,
});
export const applyClaimRecoveryPercentInSuccess = (payload) => ({
  type: OverChargeClaimsTypes.APPLY_CLAIM_RECOVERY_PERCENT_SUCCESS,
  payload,
});
export const applyClaimRecoveryPercentInError = (payload) => ({
  type: OverChargeClaimsTypes.APPLY_CLAIM_RECOVERY_PERCENT_ERROR,
  payload,
});
